import { ReactElement, useEffect } from 'react';
import { ClientResponseError } from 'pocketbase';
import { Navigate } from 'react-router-dom';
import { CollectionNames, PocketBaseService } from '@/services/pocketbase.service';

interface ProtectedRouteProps {
  children: ReactElement<any, any>;
}

const pb = PocketBaseService.getInstance().getPocketBase();

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  if (!children) {
    throw new Error('no children provided');
  }
  const token = pb.authStore.token;

  if (!token || !pb.authStore.isValid) {
    return <Navigate to="/login" />;
  }

  useEffect(() => {
    const refreshAuth = async () => {
      try {
        await pb.collection(CollectionNames.USERS).authRefresh();
      } catch (error) {
        if (error instanceof ClientResponseError) {
          if (error.status === 401 || error.status === 403) {
            pb.authStore.clear();
            window.location.href = '/login';
          }
        }
        // TODO For other errors, we can let the app continue but log them
        // TODO sentry or log to db
      }
    };

    refreshAuth();
  }, []);

  return children;
};

export default ProtectedRoute;
